import React from 'react';

import sAction from 'sAction';
import SimpleFormFromArray from 'ROOT/src/components/formElements/SimpleFormFromArray';

export default function AddNewExchangeRatePopup(props) {
    const {currency, prefix} = props.data.toJS();
    const today = new Date();

    const handleSubmit = ({year, month, exchangeRate}) => {
        if (parseInt(year) === today.getFullYear() && parseInt(month) > today.getMonth()) {
            sAction.error('You cannot add an exchange rate for current or future month.');
            return;
        }
        const id = `${currency}-${year}-${month.padStart(2, '0')}`;
        let insertIndex = null;
        const lines = sAction.dataGet(`${prefix}/customData/customLines/lines`);
        for (const [index, line] of lines.entrySeq()) {
            console.log(id, line.get('id'), id > line.get('id'));
            if (id === line.get('id')) {
                sAction.confirm(
                    `An exchange rate for ${line.get('month_text')} ${year} already exists. Do you want to overwrite it?`,
                    () => {
                        sAction.dataSet(`${prefix}/customData/customLines/lines/${index}/exchange_rate`, exchangeRate);
                        sAction.popupHide();
                        sAction.popupHide();
                    },
                );
                return;
            } else if (insertIndex == null && id > line.get('id')) {
                console.log('Setting insert index at:', index);
                insertIndex = index;
            }
        }
        sAction.dsClear();
        sAction.dsAdd('set', `${prefix}/customData/customLines/lines`, []);
        lines.forEach((line, index) => {
            if (insertIndex === index) {
                sAction.dsAdd('add', `${prefix}/customData/customLines/lines`, {
                    id,
                    year,
                    month,
                    month_text: sAction.translateEnum('dom_cal_month_long', month),
                    exchange_rate: exchangeRate,
                });
            }
            sAction.dsAdd('add', `${prefix}/customData/customLines/lines`, line);
        });
        if (insertIndex === null) {
            sAction.dsAdd('add', `${prefix}/customData/customLines/lines`, {
                id,
                year,
                month,
                month_text: sAction.translateEnum('dom_cal_month_long', month),
                exchange_rate: exchangeRate,
            });
        }
        sAction.dsProcess();
        sAction.popupHide();
    };
    return <SimpleFormFromArray
        fields={{
            year: {
                name: 'year',
                type: 'int',
                label: 'Year',
                defaultValue: today.getFullYear(),
                required: true,
            },
            month: {
                name: 'month',
                type: 'enum',
                label: 'Month',
                options: 'dom_cal_month_long',
                required: true,
            },
            exchangeRate: {
                name: 'exchangeRate',
                type: 'number',
                label: 'Exchange Rate',
                required: true,
            },
        }}
        buttons={{
            cancel: {
                label: 'Cancel',
                onClick: () => sAction.popupHide(),
                checkRequired: false,
            },
            add: {
                label: 'Add',
                onClick: handleSubmit,
            },
        }}
    />;
}
